<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-adjuster`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 14a2 2 0 012 2v6a2 2 0 01-2 2h-4v19a1 1 0 01-1 1h-2a1 1 0 01-1-1V24H8a2 2 0 01-2-2v-6a2 2 0 012-2h12zm20 10a2 2 0 012 2v6a2 2 0 01-2 2h-4v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9h-4a2 2 0 01-2-2v-6a2 2 0 012-2h12zm-2 4h-8v2h8v-2zM35 4a1 1 0 011 1v17h-4V5a1 1 0 011-1h2zM18 18h-8v2h8v-2zM15 4a1 1 0 011 1v7h-4V5a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconAdjuster',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
